import {
  type CategoryApiResponse,
  type CategoryTabOptions,
  type Filters,
  type InquiryApiResponse,
  type InquiryDetailApiResponse,
  type InquiryDetailResponse,
  type InquiryInfoApiResponse,
  type InquiryInfoResponse,
  type InquiryRequest,
  type InquiryResponse,
} from '~/features/inquiry/types/inquiry'
import { del, END_POINTS, get, patch, post } from '~/shared/http-client/api'
import { type ApiResponse } from '~/shared/http-client/exceptions/type'

export const getInquiryCategoryList = async (): Promise<
  CategoryTabOptions[]
> => {
  const response: CategoryApiResponse = await get(END_POINTS.inquiry.category)

  const categoryList = response.data.categoryList
    .sort((a, b) => a.sorting - b.sorting)
    .map((category) => ({
      value: category.code,
      label: category.description,
    }))

  return categoryList
}

export const getInquiryList = async (
  filters: Filters,
): Promise<InquiryResponse> => {
  const params = new URLSearchParams({
    page: filters.page.toString(),
    row_per_page: filters.row_per_page.toString(),
  })

  const response: InquiryApiResponse = await get(
    `${END_POINTS.inquiry.list}?${params.toString()}`,
  )

  return response.data
}

export const getInquiryDetail = async (
  id: string,
): Promise<InquiryDetailResponse> => {
  const response: InquiryDetailApiResponse = await get(
    `${END_POINTS.inquiry.detail}/${id}`,
  )

  return response.data
}

export const postInquiry = async (
  data: InquiryRequest,
): Promise<InquiryInfoResponse> => {
  const response: InquiryInfoApiResponse = await post(
    END_POINTS.inquiry.create,
    { info: data },
  )

  return response.data
}

export const patchInquiry = async (
  data: InquiryRequest,
): Promise<InquiryInfoResponse> => {
  const response: InquiryInfoApiResponse = await patch(
    END_POINTS.inquiry.update,
    { info: data },
  )

  return response.data
}

export const deleteInquiry = async (id: string): Promise<ApiResponse> => {
  const response: ApiResponse = await del(`${END_POINTS.inquiry.delete}/${id}`)

  return response
}
